export default __webpack_public_path__ + "static/FairplexWide-BookItalic-2245650fbda74ee753612c50a50a5d44.woff2";